/** @jsxImportSource @emotion/react */
import {useDispatch, useSelector} from 'react-redux';
import {IAppState} from '../../core/redux/IAppState';
import HotlistModal, {State} from './HotlistModal';
import {QuickEntitlement} from '../entitlements/models';
import {Resort} from '../../resortDetails/resort';
import {addToHotlistAction} from './addToHotlistAction';
import {validateHotlistAdd} from './module';
import * as R from 'ramda';
import ModalView, {ModalContent} from '../../layout/modal/ModalView';
import {MODAL_SIZE} from '../../layout/modal/modalSize';
import {css} from '@emotion/react';
import ModalTitleHeader from '../../layout/modal/ModalTitleHeader';
import flame from '../../assets/icons/flame.svg';
import ImmutableMap from '../../language/ImmutableMap';
import {fullName} from '../module';
import * as React from 'react';
import {EntitlementType} from '../../entitlementTypes/entitlementType';
import { getResource } from '../../language/resources/getResource';
import { PhoneNumberUtil, PhoneNumberFormat as PNF, PhoneNumber } from 'google-libphonenumber';

type Props = {
  guestId: string;
  onDismiss: () => void;
  allEntitlementTypes: ImmutableMap<EntitlementType>;
}

const phoneUtil = PhoneNumberUtil.getInstance();

const alterraResorts = ["AB", "BB", "BM", "CORP", "CR", "DV", "JU", "MM", "SQ", "SZ", "SS", "SVMR", "SN", "SO", "SB", "ST", "SG", "TR", "WP"];

const AddToHotlistModal = (props: Props) => {

  const {guest, resortList, resources} = useSelector((state: IAppState) => ({
    guest: state.guests.get(props.guestId),
    resortList: state.resortDetails?.allResorts?.getValues(),
    selectedResort: state.selectedResort,
    resources: state.locale
  }));
  const dispatch = useDispatch();

  const onAddToHotlist = (masterGuestId: string, entitlement: QuickEntitlement, resortAbbrev: string,
                          isGlobalHotlist: boolean, effectiveDate: Date, expirationDate: Date, typeId: number, comments: string,
                          resortList: Resort[], resortContactNumber: string) => {
    if (resortContactNumber) {
      // prepend resort contact number to comment
      comments = getResource(resources, "HOTLIST_COMMENT_WITH_REPORTER_CONTACT",resortContactNumber, comments);
    }

    dispatch(addToHotlistAction(masterGuestId, entitlement, resortAbbrev, isGlobalHotlist,
      effectiveDate, expirationDate, typeId, comments, resortList))
  }

  const onSubmitEntitlementHotlistHandler = (givenState: State) => {
    const phoneNumber: PhoneNumber | undefined = givenState.phoneNumberValue && givenState.phoneNumberCountry ? 
    phoneUtil.parse(givenState.phoneNumberValue, givenState.phoneNumberCountry) : undefined;
    if (phoneNumber && givenState.phoneNumberExtension) {
      phoneNumber.setExtension(givenState.phoneNumberExtension);
    }
    const formattedPhoneNumber = phoneNumber ? phoneUtil.format(phoneNumber, PNF.INTERNATIONAL) : '';
    
    /*if (givenState.selectedResort!.resortId == -1) {
      alterraResorts.forEach(abbrev => onAddToHotlist(guest!.masterGuestId,
      givenState.selectedEntitlement!, abbrev,
      givenState.usingGlobalHotlist, givenState.hotlistEffectiveDate, givenState.hotlistExpirationDate,
      givenState.hotlistType!.id, givenState.comments.trim(), resortList || [], 
      formattedPhoneNumber)) 
    }*/
    
    onAddToHotlist(guest!.masterGuestId,
      givenState.selectedEntitlement!, givenState.selectedResort!.resortAbbreviation,
      givenState.usingGlobalHotlist, givenState.hotlistEffectiveDate, givenState.hotlistExpirationDate,
      givenState.hotlistType!.id, givenState.comments.trim(), resortList || [], 
      formattedPhoneNumber)
    };

  const validateEntitlementHotlistSubmission = (givenState: State) =>
    validateHotlistAdd(
      resources,
      givenState.selectedEntitlement,
      givenState.selectedResort,
      givenState.hotlistEffectiveDate, 
      givenState.hotlistExpirationDate,
      R.path([ 'hotlistType', 'id' ], givenState),
      givenState.comments, 
      givenState.phoneNumberValue, 
      givenState.phoneNumberCountry,
      givenState.phoneNumberExtension,
    );

  return (
    <ModalView onDismiss={props.onDismiss}
               size={MODAL_SIZE.SMALL}
               contentCss={css`position: relative;`}>
      <ModalTitleHeader resources={resources}
                        heading={getResource(resources, 'HOTLIST_ADD_HOTLIST')}
                        icon={flame}
                        onDismiss={props.onDismiss}
      />
      <ModalContent>
        <HotlistModal
          resources={resources}
          guestId={props.guestId}
          allEntitlementTypes={props.allEntitlementTypes|| ImmutableMap.empty()}
          alterraResorts={alterraResorts}
          onDismiss={props.onDismiss}
          validateHotlistSubmission={validateEntitlementHotlistSubmission}
          onSubmitHandler={onSubmitEntitlementHotlistHandler}
          onSubmitSuccess={props.onDismiss}
          submitButtonTitle={getResource(resources, 'HOTLIST_PUT_HOTLIST', fullName(guest))}
          submitButtonText={getResource(resources, 'HOTLIST_ADD_HOTLIST')}
        />
      </ModalContent>
    </ModalView>
  );
}

export default AddToHotlistModal;